import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class ChatGptUtilityListingService extends BaseService {
  constructor() {
    super(constants.GET_CHATGPT_LISTING_DATA, 'ChatGptUtilityListingStatus');
  }

  handleEvent(eventName, event) {
    const { tenantId, ...payload } = event.payload;
    const headers = { 'x-berlin-tenant-id': tenantId };
    return this.getClient('evergreen').post(`/trendsInsights/cluster`, payload, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success' && data.data.length > 0) {
      Framework.getStoreRegistry().getStore('chatgptListingUtility').setResponse(response.data);
    }
    if (data.status === 'success' && data.data.length === 0) {
      const notification = {
        open: true,
        type: 'error',
        message: 'No Data Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
      Framework.getStoreRegistry().getStore('chatgptListingUtility').setResponse(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    } else if (error.message === 'timeout of 60000ms exceeded') {
      const notification = {
        open: true,
        message: error.message,
        type: 'error'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.getStoreRegistry().getStore('chatgptListingUtility').resetStoreValues();
  }
}
